import { Color, Icon, VerticalLineSVG } from '@bb/elements-web';
import React from 'react';
import styled from 'styled-components';

function UpcomingChangesIcons({
  showTwoIcons = true,
}: {
  showTwoIcons?: boolean;
}) {
  return (
    <IconWrapper>
      <Icon icon="carryOutTwoTone" color="primary" size={24} />
      {showTwoIcons && <VerticalLineSVG color={Color.PRIMARY} />}
      {showTwoIcons && (
        <Icon icon="clockCircleOutlined" color="primary" size={24} />
      )}
    </IconWrapper>
  );
}

export default UpcomingChangesIcons;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;
